import { Component, forwardRef, Input, OnDestroy, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Subject } from "rxjs";

const SWITCHER_MODEL_INPUT: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputSwitcherComponent),
  multi: true,
};

@Component({
  selector: "app-input-switcher",
  templateUrl: "./input-switcher.component.html",
  styleUrls: ["./input-switcher.component.scss"],
  providers: [SWITCHER_MODEL_INPUT],
})
export class InputSwitcherComponent implements ControlValueAccessor, OnInit,OnDestroy {
  @Input() options: any;
  private destroy$ = new Subject<void>();
  private _selectedOption: any;
  get selectedOption(): any {
    return this._selectedOption;
  }

  set selectedOption(newName: any) {
    if(newName){
    this._selectedOption = newName;
    this.emitChanges();
    }
  }

  constructor() {}

  ngOnInit(): void {
    if (!this.selectedOption) {
      this.selectedOption =  this.options[0];
    }
  }

  OnChange = (_: any) => {};

  emitChanges() {
    if (this.selectedOption && typeof this.selectedOption === "object") {
      this.OnChange(this.selectedOption.value);
    } else {
      this.OnChange(this.selectedOption);
    }
  }

  writeValue(val: any): void {
    if (typeof this.options[0] === "string" || val === null) {
      this.selectedOption = val;
    } else {
      this.selectedOption = this.options.find((e) => e.value === val);
    }

    // if (this.options.indexOf(val) != -1 ||  val === null) {
    // } else {
    //   console.error("Value" + val + "passed in to switch control does not match any option");
    // }
  }

  registerOnChange(fn: any): void {
    this.OnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState?(isDisabled: boolean): void {
    // Implement Later;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
